<template>
    <div>
        <ul class="nav nav-pills nav-justified" role="tablist">
            <li v-for="progress in $i18n.messages[$i18n.locale].tab.rewardFormProgressTabs" :key="progress.id" class="nav-item">
                <a :class="{'active': selectedTab == progress.id}" class="nav-link border-bottom-left-radius-0 border-bottom-right-radius-0" data-toggle="tab">{{progress.id}}. {{progress.text}}</a>
            </li>
        </ul>
        <div class="tab-content mt-5">
            <div class="tab-pane" :class="{'active': selectedTab == 1}">
                <div class="text-left border-top pt-3 mb-3">
                    <rewardFormInfo ref="rewardFormInfo" :isEdit="isEdit" @returnRewardList="returnRewardList" @submitPromoInfo="submitReward"></rewardFormInfo>
                </div>
            </div>
            <div class="tab-pane" :class="{'active': selectedTab == 2}">
                <div class="text-left border-top pt-3 mb-3">
                    <rewardFormValue ref="rewardFormValue" :isEdit="isEdit" @returnRewardList="returnRewardList" @returnPreviousStep="returnPreviousStep" @submitPromoValue="submitReward"></rewardFormValue>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import axios from 'axios'
import RewardFormValue from './Reward_Form_Value'
import RewardFormInfo from './Reward_Form_Info'
import tab from '@/assets/js/dashboard/tab.js'
import {handleSessionExpired} from '@/assets/js/dashboard/dashboard.js'
export default {
    name: "rewardForm",
    props: {
        isEdit: { type: Boolean },
    },
    components:{
        RewardFormInfo, RewardFormValue
    },
    data(){
        return{
            selectedTab: 1,
            promoData: {}, rewardID: 0, outletID: 0,
            
        }
    },
    methods:{
        returnRewardList(selectedOutlet){
            this.$emit('returnRewardList', selectedOutlet)
        },
        returnPreviousStep(step){
            this.selectedTab = step;
        }, 
        editReward(data){
            this.rewardID = data.rewardID;
            this.outletID = data.outletID;
            this.$refs.rewardFormInfo.editReward(data)
            this.$refs.rewardFormValue.editReward(data)
        },
        submitReward(data, step){
            let $vm = this
            if(step < 2){
                this.selectedTab = step + 1;
                Object.assign(this.promoData, data)
            }else{
                Object.assign(this.promoData, data)
                
                var url = this.$api.OUTLET + "/" + + this.promoData.outlet.id  + this.$api.MENU_REWARD_QR;
                url += this.isEdit ? "/" + this.rewardID + this.$api.UPDATE : ""
                
                delete this.promoData.outletID
                this.$axios({
                    method: 'post', 
                    url: url,
                    baseURL: this.$axios.defaults.baseURL, 
                    headers: {token: this.$util.getSessionToken()},
                    data: this.promoData
                })
                .then((response) => {
                    if(response.status == 200){
                        var retData = response.data[0];
                        var action =  $vm.isEdit ? $vm.$i18n.t('message.success.action.update') : $vm.$i18n.t('message.success.action.add')
                        var message =  "'" + retData.title + "'" + $vm.$i18n.t('message.success.success',{'action': action})
                        this.$parent.$parent.$parent.setModal(this, false, true, message)
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if(errData.error == $vm.$api.INVALID_TOKEN){
                        handleSessionExpired();   
                    }
                })
            }
        },
        closeModal(isError){
            if(!isError){
                this.returnRewardList(this.promoData.outlet)
            }
            this.$parent.$parent.$parent.isModalShow = false;
        }
    }
}
</script>
